function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "logo_facebook");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "logo_facebook",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M58.514062,61.9324729 C60.4014574,61.9324729 61.9319922,60.401938 61.9319922,58.514062 L61.9319922,3.41817054 C61.9319922,1.53005426 60.4016977,0 58.514062,0 L3.41817054,0 C1.53005426,0 0,1.53005426 0,3.41817054 L0,58.514062 C0,60.4016977 1.52981395,61.9324729 3.41817054,61.9324729 L58.514062,61.9324729 Z",
  id: "Blue_1_",
  fill: "#BDBDBD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.7321783,61.9324729 L42.7321783,37.9488062 L50.7823256,37.9488062 L51.9877209,28.6019457 L42.7321783,28.6019457 L42.7321783,22.6345659 C42.7321783,19.9284341 43.4836279,18.0842946 47.364155,18.0842946 L52.3135814,18.0821318 L52.3135814,9.7222248 C51.4575969,9.6083178 48.5195659,9.3538295 45.1013953,9.3538295 C37.9653876,9.3538295 33.0798837,13.7096899 33.0798837,21.7088915 L33.0798837,28.6019457 L25.0090698,28.6019457 L25.0090698,37.9488062 L33.0798837,37.9488062 L33.0798837,61.9324729 L42.7321783,61.9324729 Z",
  id: "f",
  fill: "#FFFFFF"
})));

var SvgLogoFacebookGrey = function SvgLogoFacebookGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoFacebookGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_facebook_grey.97cbe750.svg";
export { ForwardRef as ReactComponent };